import { useMemo } from 'react';
import { createEmptyGroup, addWorklogToGroup, calculateFinalMetrics, groupByParent } from '../utils/groupingUtils';

const useGroupedWorklogs = (filteredWorkLogs, groupingField) => {
  return useMemo(() => {
    if (groupingField === 'none') return { ungrouped: filteredWorkLogs };

    // Special handling for parent grouping
    if (groupingField === 'Parent') {
      return groupByParent(filteredWorkLogs);
    }

    // Handle other grouping types
    const grouped = filteredWorkLogs.reduce((acc, log) => {
      let groupKey;
      let groupLabel;
      
      switch (groupingField) {
        case 'issue':
          groupKey = log.issue_key;
          groupLabel = `🎫 ${groupKey}`;
          break;
        case 'worklogAuthor':
          groupKey = log.author || 'Unknown Author';
          groupLabel = `👤 ${groupKey}`;
          break;
        case 'issueAssignee':
          groupKey = log.issue_assignee || 'Unassigned';
          groupLabel = `🎯 ${groupKey}`;
          break;
        case 'project':
          groupKey = log.issue_project_name || log.issue_project_key;
          groupLabel = `📁 ${groupKey}`;
          break;
        case 'status':
          groupKey = log.issue_status;
          groupLabel = `📊 ${groupKey}`;
          break;
        case 'priority':
          groupKey = log.issue_priority || 'No Priority';
          groupLabel = `🏷️ ${groupKey}`;
          break;
        case 'date':
          groupKey = log.loggedDate;
          groupLabel = `📅 ${groupKey}`;
          break;
        case 'sprint':
          groupKey = log.issue_sprint || 'No Sprint';
          groupLabel = `🏃 ${groupKey}`;
          break;
        default:
          groupKey = 'other';
          groupLabel = 'Other';
      }

      if (!acc[groupKey]) {
        acc[groupKey] = createEmptyGroup(groupLabel, log);
      }

      addWorklogToGroup(acc[groupKey], log);
      return acc;
    }, {});

    // Calculate final metrics for each group
    Object.values(grouped).forEach(calculateFinalMetrics);

    return grouped;
  }, [filteredWorkLogs, groupingField]);
};

export default useGroupedWorklogs;

